export const ImageUploadFields = {
  devicePixelRatio: 'devicePixelRatio',
  lastModified: 'lastModified',
};
